import { makeStyles } from '@material-ui/core';
import React from 'react';
import { TeamImage } from '../odds/TeamImage';


const teamEventStyles = makeStyles(theme => ({
    container: {
        zIndex: 5,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '90%',
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: '40px',
        "& p": {
            color: 'black',
            margin: 0,
            overflow: 'none',
        },
    },
    teamImage: {
        width: 50,
        height: 50,
        objectFit: 'contain',
        [theme.breakpoints.down('600')]: {
            width: 40,
        },
    },
}));

export const TeamHeader = ({ competitor, league }) => {
    const classes = teamEventStyles();
    return (
        <div className={classes.container}>
            <TeamImage className={classes.teamImage} competitor={competitor} league={league} />
        </div>
    )
}